
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/[uid]",
      function () {
        return require("private-next-pages/events/[uid].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/[uid]"])
      });
    }
  